export const QuickApplicationStatus = {
  InProgress: 1,
  Declined: 2,
  Accepted: 4,
  Active: 5,
  Completed: 7
};
